export function parseQuantity(value, integer = false) {
  if (!/^\d+([.,]\d{1,2})?$/.test(value.trim())) return null;
  const number = Number(value.replace(',', '.'));
  return number > 0 && number <= 100000 && (!integer || Number.isInteger(number)) ? number : null;
}
export function requiredMaterial(quantity, extra = 0) {
  return Math.ceil(Math.round(quantity * 100) * (100 + extra) / 100) / 100;
}
class SmidProductQuote extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.form = this.querySelector('form');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (/^\d+$/.test(preview || '') && !this.form.elements.preview_theme_id) {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview; this.form.append(input);
    }
    this.button = this.querySelector('button[type=submit]');
    this.addEventListener('input', () => this.update(), { signal });
    this.addEventListener('change', () => this.update(), { signal });
    this.form.addEventListener('submit', event => {
      this.update();
      const options = this.querySelector('smid-sunshade-options');
      if (this.pending || this.button.disabled || (options && options.dataset.valid !== 'true') || !this.form.reportValidity()) event.preventDefault();
    }, { signal });
    this.closest('.shopify-section')?.addEventListener('shopify:product:select', event => this.variantChanged(event), { signal });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
  update() {
    const unit = this.form.elements.eenheid.value;
    const integerUnit = !['m2', 'meter', 'kg', 'liter'].includes(unit);
    for (const input of this.querySelectorAll('[data-positive-number]')) {
      input.setCustomValidity(input.value && parseQuantity(input.value, input.name === 'hoeveelheid' && integerUnit) === null ? 'Vul een geldig positief getal in (maximaal 100.000).' : '');
    }
    const amount = parseQuantity(this.form.elements.hoeveelheid.value, integerUnit);
    const output = this.querySelector('output');
    output.hidden = amount === null;
    if (amount !== null) {
      const total = requiredMaterial(amount, Number(this.form.elements.extra?.value || 0));
      output.textContent = `Aan te vragen: ${new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 }).format(total)} ${unit === 'm2' ? 'm\u00b2' : unit}`;
    }
  }
  async variantChanged(event) {
    if (event.target instanceof Element && event.target.closest('product-card')) return;
    const request = (this.request || 0) + 1;
    this.request = request;
    this.pending = true;
    this.button.disabled = true;
    const error = this.querySelector('.spq-error');
    error.hidden = true;
    try {
      const { detail } = await event.promise;
      if (request !== this.request || !this.isConnected) return;
      const next = [...detail.html.querySelectorAll('smid-product-quote')].find(node => node.dataset.blockId === this.dataset.blockId);
      if (!next || !detail.resource) throw new Error('No variant');
      for (const name of ['product', 'variant', 'variant_id', 'sku', 'product_url']) {
        this.form.elements[name].value = next.querySelector(`[name="${name}"]`).value;
      }
      this.dataset.productId = next.dataset.productId;
      const oldOptions = this.querySelector('smid-sunshade-options');
      const nextOptions = next.querySelector('smid-sunshade-options');
      if (oldOptions && nextOptions) oldOptions.replaceWith(nextOptions.cloneNode(true));
      else if (oldOptions) oldOptions.remove();
      else if (nextOptions) this.form.querySelector('.spq-fields').before(nextOptions.cloneNode(true));
      this.button.disabled = false;
    } catch {
      if (request !== this.request || !this.isConnected) return;
      error.textContent = 'Deze uitvoering kon niet worden geladen. Kies opnieuw een uitvoering of vernieuw de pagina.';
      error.hidden = false;
    } finally {
      if (request === this.request) this.pending = false;
    }
  }
}
if (typeof customElements !== 'undefined' && !customElements.get('smid-product-quote')) customElements.define('smid-product-quote', SmidProductQuote);
